import React from "react";
import { BellRing } from "lucide-react";
import { formatDateTime } from "@/admin/adminApi";

export default function SeatFreedAlerts({ sessions, programs, onPick }) {
  if (!sessions?.length) return null;
  return (
    <div data-testid="seat-freed-alerts" className="border border-[#A07A28] bg-[#FBF5E6] px-5 md:px-6 py-4 space-y-2.5">
      {sessions.map((s) => (
        <div key={s.id} data-testid={`seat-freed-alert-${s.id}`} className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
          <p className="flex items-start gap-3 font-body text-[14px] text-graphite">
            <BellRing className="w-4 h-4 mt-0.5 text-gold flex-shrink-0" />
            <span>
              <strong className="font-medium">Felszabadult hely:</strong> {programs[s.program_id] || "—"}, {formatDateTime(s.starts_at)} —{" "}
              {s.free} szabad hely, {s.waitlist} fő a várólistán.
            </span>
          </p>
          {onPick && (
            <button type="button" onClick={() => onPick(s)} data-testid={`seat-freed-show-${s.id}`} className="font-body text-[13px] text-gold border-b border-gold self-start md:self-auto whitespace-nowrap">
              Várólista megnyitása
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
